module.exports = "Aucune campagne au nom\n\nde **« {{query}} »** trouvée"


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/campaigns/i18n/markdown/fr/noCampaignFoundForSearch.md
// module id = ./src/statsradio/modules/campaigns/i18n/markdown/fr/noCampaignFoundForSearch.md
// module chunks = 18